import { GET, URLS, POST, PUT, PATCH, SET_VALUE, DELETE } from '../../utils'
import { types as LoadingTypes } from './loading'
import { types as ToastTypes } from './toast'
import ROUTER from '@/router.js'

/**
 * 活动的状态管理
 */

export const types = {
  /**
   * 列表请求
   */
  FETCH_LIST_ACTIVITY: 'ACTIVITY/FETCH_LIST_ACTIVITY',

  /**
   * 详情请求
   */
  FETCH_DETAIL_ACTIVITY: 'ACTIVITY/FETCH_DETAIL_ACTIVITY',

  /**
   * 某活动下视频作品列表请求
   */
  FETCH_LIST_ACTIVITY_VIDEO: 'ACTIVITY/FETCH_LIST_ACTIVITY_VIDEO',

  /**
   * 视频作品新建请求
   */
  FETCH_CREATE_ACTIVITY_VIDEO: 'ACTIVITY/FETCH_CREATE_ACTIVITY_VIDEO',

  /**
   * 活动报名请求
   */
  FETCH_APPLY_ACTIVITY: 'ACTIVITY/FETCH_APPLY_ACTIVITY',


  SET_CURRENT_ACTIVITY: 'ACTIVITY/SET_CURRENT_ACTIVITY'

}

const state = {
  // 活动列表
  activity: {
    page: 1,
    page_size: 10,
    load_more: false,
    data: [],
    total_count: 0,
  },
  // 视频类表
  activity_video: {
    page: 1,
    page_size: 10,
    load_more: false,
    data: [],
    total_count: 0,
  },

  // arr:null,

  // 当前活动
  currentActivity: null,

}

const mutations = {
  set_load_more(state, param) {
    // param: {"value": true, "data_type":"member"}
    if (param.data_type === types.FETCH_LIST_ACTIVITY) {
      state.activity.load_more = param.value
    } else if (param.data_type === 'activity_video') {
      state.activity_video.load_more = param.value
    }
  },
  set_pagenum(state, param) {
    // param: {"value": 3, "data_type":"member"}
    if (param.data_type === types.FETCH_LIST_ACTIVITY) {
      state.activity.page = param.value
    } else if (param.data_type === 'activity_video') {
      state.activity_video.page = param.value
    }
  },
  set_list_data(state, param) {
    // param: {"data": [], "data_type":"member"}
    let temp_state = null;
    if (param.data_type === types.FETCH_LIST_ACTIVITY) {
      // console.log(param,"param")
      temp_state = state.activity
    } else if (param.data_type === 'activity_video') {
      temp_state = state.activity_video
    }
    if (temp_state) {
      if (temp_state.page === 1) {
        param.data.sort(function (a, b) {
          return (new Date(b.start_time) - new Date(a.start_time))
        })
        temp_state.data = param.data
      } else {
        temp_state.data = temp_state.data.concat(param.data)
        temp_state.data.sort(function (a, b) {
          return (new Date(b.start_time) - new Date(a.start_time))
        })
      }
      temp_state.total_count = param.count
    }
  },
  update_list_data(state, param) {
    if (param.data_type === types.FETCH_LIST_ACTIVITY) {
      state.activity.data.unshift(param.data)
    } else if (param.data_type === 'activity_video') {
      state.activity_video.data.unshift(param.data)
    }
  },

  [types.SET_CURRENT_ACTIVITY](state, param) {
    state.currentActivity = param
  }
}

const actions = {
  /**
   * 列表
   * @param {*} param {"page":1}
   */
  [types.FETCH_LIST_ACTIVITY]({ commit, state }, param) {
    // param: {"page":1}
    // 打开等待动画
    commit(LoadingTypes.SHOW)
    let temp_dic = { 'data_type': types.FETCH_LIST_ACTIVITY }
    commit('set_load_more', { ...temp_dic, 'value': false })
    commit('set_pagenum', { ...temp_dic, 'value': param.page })

    GET(URLS.list_activity(param.page)).then(response => {
      // console.log(response) 
      // state.arr=response.results
      // 更新 load_more 

      if (response.next) {

        commit('set_load_more', { ...temp_dic, 'value': true })

      } else {
        commit('set_load_more', { ...temp_dic, 'value': false })
      }

      // 跟新数据源
      commit('set_list_data', { ...temp_dic, 'data': response.results, 'count': response.count })
      // if(response){
      //   this.arr=response.results
      // }
      // 移除等待动画
      commit(LoadingTypes.HIDE)
    })

  },

  /**
   * 详情
   * @param {*} param {"pk":1}
   */
  [types.FETCH_DETAIL_ACTIVITY]({ commit }, param) {
    // 打开等待动画
    commit(LoadingTypes.SHOW)

    let pk = param.pk
    GET(URLS.detail_activity(pk)).then(response => {
      // 更新数据源
      commit(types.SET_CURRENT_ACTIVITY, response)
      // 移除等待动画
      commit(LoadingTypes.HIDE)
    })
  },

  /**
   * 活动视频列表
   * @param {*} param {"page":1, "activity_number":1}
   */
  [types.FETCH_LIST_ACTIVITY_VIDEO]({ commit, state }, param) {
    // param: {"page":1}
    // 打开等待动画
    commit(LoadingTypes.SHOW)
    let temp_dic = {
      data_type: "activity_video"
    }
    commit('set_load_more', { ...temp_dic, value: false })
    commit('set_pagenum', { ...temp_dic, value: param.page })

    GET(URLS.activity_videos(param.activity_number, param.page)).then(
      response => {
        // 更新 load_more
        if (response.next) {
          commit('set_load_more', { ...temp_dic, value: true })
        } else {
          commit('set_load_more', { ...temp_dic, value: false })
        }

        // 跟新数据源
        commit('set_list_data', {
          ...temp_dic,
          data: response.results,
          count: response.count
        })

        // 移除等待动画
        commit(LoadingTypes.HIDE)
      }
    )
  },

  /**
   * 活动视频新建
   */
  [types.FETCH_CREATE_ACTIVITY_VIDEO]({ commit, state }, param) {
    // param: {"page":1}
    // 打开等待动画
    commit(LoadingTypes.SHOW)
    let temp_dic = {
      data_type: "activity_video"
    }
    POST(URLS.activity_videos_create(param.activity_number), param).then(
      response => {
        commit('update_list_data', { ...temp_dic, 'data': response })

        // 移除等待动画
        commit(LoadingTypes.HIDE)
      }
    )
  },

  /**
   * 活动报名
   * @param {*} param {"number":1}
   */
  [types.FETCH_APPLY_ACTIVITY]({commit}, param){
    let url = URLS.apply_activity_record(param.number)
    return new Promise((resolve, reject) => {
      POST(url).then(response => {
        // commit(ToastTypes.SHOW, {message:"报名成功"})
        resolve(response)
      })
    });
  }


}
const getters = {

}

export default {
  state,
  mutations,
  actions,
  getters
}
